module.exports = __webpack_public_path__ + "static/media/delivery-icon--white.a71e36d9.svg";